<template>
  <div class=" bg-white/60 rounded-xl min-h-screen">
    <div
        v-if="isSubmitting"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]"
    >
      <div class="flex flex-col items-center">
        <svg class="animate-spin h-10 w-10 text-white mb-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-white text-sm">در حال پردازش...</span>
      </div>
    </div>
    <div
        v-if="showBulkUpdate"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
    >
      <div class="bg-white rounded-lg shadow-lg w-72 p-4">
        <h2 class="text-lg font-semibold mb-3">انتخاب نوع سود</h2>

        <select
            v-model="bulkType"
            class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right ring-blue-400"
        >
          <option value="percent">درصد</option>
          <option value="amount">مبلغ</option>
        </select>

        <div class="flex justify-end space-x-2 mt-2">
          <button
              @click="showBulkUpdate = false"
              class="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
          >
            بستن
          </button>
          <button
              @click="bulkTypeUpdate(bulkType)"
              class="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 mr-2"
          >
            اعمال
          </button>

        </div>
      </div>
    </div>
    <div
        v-if="showBulkAmountUpdate"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
    >
      <div class="bg-white rounded-lg shadow-lg w-72 p-4">
        <h2 class="text-lg font-semibold mb-3">حاشیه سود دسته جمعی</h2>

        <label class="text-xs text-gray-600 font-semibold mb-2">حاشیه سود</label>
        <input
            v-model="bulkAmount"
            type="number"
            class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right ring-blue-400"
        >

        <div class="flex justify-end space-x-2 mt-2">
          <button
              @click="showBulkAmountUpdate = false"
              class="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 mr-2"
          >
            بستن
          </button>
          <button
              @click="bulkAmountUpdate(bulkAmount)"
              class="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 mr-2"
          >
            اعمال
          </button>

        </div>
      </div>
    </div>

    <div class="">
      <div class="bg-white rounded-t-xl  p-6 mb-1">
        <div class="flex justify-between items-center">
          <h6 class=" font-bold text-purple-600">
             <span
                 class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500">
                 اکسل پکینگ در انتظار تایید
             </span>
          </h6>
          <div class="text-sm text-gray-500">
            شناسه فایل: <span class="font-bold text-purple-600">{{ packing.id }}</span>
          </div>
          <div class="text-sm text-gray-500">
            نام : <span class="font-bold text-purple-600">{{ packing.name }}</span>
          </div>
          <div class="text-sm text-gray-500">
            تاریخ : <span class="font-bold text-purple-600">{{ packing.date }}</span>
          </div>
        </div>
        <div
            class="bg-white mt-5 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-4 mb-6 shadow-sm border border-gray-100">
          <div class="flex flex-wrap items-center gap-3">

            <div class="flex flex-col w-40">
              <label class="text-xs text-gray-600 font-semibold mb-2">عنوان</label>
              <input
                  v-model="body.title"
                  class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right"
              >
            </div>

            <div class="flex flex-col w-40">
              <label class="text-xs text-gray-600 font-semibold mb-2">شماره فاکتور</label>
              <input
                  v-model="body.factor_number"
                  class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right"
              >
            </div>
            <div class="flex flex-col w-40 ">
              <label class="text-xs text-gray-600 font-semibold mb-2">تامین کننده</label>
              <select
                  v-model="body.supplier"
                  class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right"
              >
                <option :value="null">انتخاب تامین کننده</option>
                <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">
                  {{ supplier.name }}
                </option>
              </select>
            </div>

            <div class="flex flex-col w-40" v-if="!packing.domestic">
              <label class="text-xs text-gray-600 font-semibold mb-2">ارز</label>
              <select
                  @change="calculateAllProfits"
                  v-model="body.currency"
                  class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right"
              >
                <option :value="null">انتخاب ارز</option>
                <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                  {{ currency.name }}
                </option>
              </select>
            </div>

            <div class="flex flex-col w-40" v-if="!packing.domestic">
              <cleave-money
                  :required="false"
                  label="هزینه ارسال چین تا دوبی"
                  v-model="body.initial_shipping_cost"
                  :currency-unit="currentCurrency.name"
              ></cleave-money>
            </div>

            <div class="flex flex-col w-40" v-if="!packing.domestic">
              <cleave-money
                  :required="false"
                  label="هزینه ارسال دوبی تا ایران"
                  v-model="body.additional_shipping_cost"
                  :currency-unit="currentCurrency.name"
              ></cleave-money>
            </div>
            <div class="flex flex-col w-40">
              <label class="text-xs text-gray-600 font-semibold mb-2"></label>
              <cleave-money
                  :required="false"
                  label="هزینه ارسال داخلی"
                  v-model="body.cargo_cost_per_shipping"
                  currency-unit="تومان"
              ></cleave-money>
            </div>
            <div class="flex flex-col col-span-3 w-96">
              <label class="text-xs text-gray-600 font-semibold mb-2">توضیحات</label>
              <input
                  v-model="body.explanation"
                  class="px-2 py-2 bg-gray-100 text-sm rounded-lg border w-full text-right"
              >
            </div>

            <div class="flex items-end font-semibold pt-4">
              <button
                  @click="handleDone"
                  class="px-4 py-2 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105 text-sm"
                  title="تایید نهایی"
              >
                تایید نهایی
              </button>
            </div>

          </div>
        </div>

        <div class="flex flex-wrap gap-2 mt-2 text-xs">
          <div class="flex items-center bg-purple-50 p-2 rounded-lg border border-purple-200">
            <div class="bg-purple-100 p-2 rounded-full">
              <i class="fas fa-cube text-purple-600"></i>
            </div>
            <div class="mr-2">
              <span class="text-purple-500">تعداد کل آیتم‌ها</span>
              <span class="font-bold mr-3">{{ items.length }}</span>
            </div>
          </div>

          <div v-if="!packing.domestic" class="flex items-center bg-green-50 p-2 rounded-lg border border-green-200">
            <div class="bg-green-100 p-2 rounded-full">
              <i class="fas fa-boxes text-green-600"></i>
            </div>
            <div class="mr-2">
              <span class="text-green-500">تعداد کل کارتون‌ ها</span>
              <span class="font-bold mr-3">{{ totalBoxQuantity }}</span>
            </div>
          </div>
          <div class="flex items-center bg-pink-50 p-2 rounded-lg border border-pink-200"
               v-if="body.currency && !packing.domestic">
            <div class="bg-pink-100 p-2 rounded-full">
              <i class="fas fa-coins text-pink-600"></i>
            </div>
            <div class="mr-2">
              <span class="text-pink-500">مجموع به تومان</span>
              <span
                  class="font-bold mr-3">{{ totalAmount * currentCurrency.exchange_rate_to_toman | toMoney(6) }}</span>
              <span class="text-pink-500 text-xs mr-3">تومان</span>
            </div>
          </div>
          <div class="flex items-center bg-pink-50 p-2 rounded-lg border border-pink-200" v-if="packing.domestic">
            <div class="bg-pink-100 p-2 rounded-full">
              <i class="fas fa-coins text-pink-600"></i>
            </div>
            <div class="mr-2">
              <span class="text-pink-500">مجموع به تومان</span>
              <span class="font-bold mr-3">{{ packing.total_amount_sum | toMoney(0) }}</span>
              <span class="text-pink-500 text-xs mr-3">تومان</span>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-y-auto " style="max-height: calc(100vh - 38vh);">
        <table class="min-w-full text-sm table-auto">
          <thead class="bg-gray-900 border border-red-50 sticky top-0 z-10">
          <tr>
            <th class="text-[8px]  text-white text-center p-1 border  w-1">ردیف</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">تصویر</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">کد محصول</th>
            <th class="text-[8px]  text-white text-center p-1 border w-min">sku</th>
            <th class="text-[8px]  text-white text-center p1 border w-44">نام محصول</th>
            <th v-if="!packing.domestic" class="text-[8px]  text-white text-center p-1 w-min whitespace-nowrap border">
              چیدمان کارتون
            </th>
            <th v-if="!packing.domestic" class="text-[8px]  text-white text-center p-1 w-min whitespace-nowrap border">
              تعداد در کارتون
            </th>
            <th v-if="!packing.domestic" class="text-[8px]  text-white text-center p-1 w-min whitespace-nowrap border">
              تعداد کارتون
            </th>
            <th class="text-[8px]  text-white text-center p-1 w-min whitespace-nowrap border">تعداد کل</th>
            <th v-if="packing.domestic" class="text-[8px]  text-white text-center p-1 w-min whitespace-nowrap border">
              قیمت مصرف کننده
            </th>
            <th
                v-if="packing.domestic"
                class="text-[8px] text-white text-center p-1 border w-10 whitespace-nowrap max-w-xs"
                title="درصد کمتر از قیمت مصرف‌کننده"
            >
              ٪کمتر از مصرف
            </th>
            <th class="text-[8px]  text-white text-center p-1 whitespace-nowrap" style="width:1px">
              قیمت پایه
              <span v-if="body.currency" class="text-green-200">
                ( {{ currentCurrency.name }} )
              </span>
            </th>
            <th class="text0xs text-white text-center p-1 w-12 whitespace-nowrap border">نوع حاشیه سود
              <button
                  @click="showBulkUpdate = true"
                  class=" text-[8px]  text-red-400 "
              >
                تغییر همه
              </button>
            </th>
            <th class="text-xs text-white text-center p-1 w-10 whitespace-nowrap border">حاشیه سود
              <button
                  @click="showBulkAmountUpdate = true"
                  class=" text-[8px] text-red-400  "
              >
                تغییر همه
              </button>

            </th>
            <th class="text-[8px]  text-white text-center p-1 w-min whitespace-nowrap border"> در صورت فروش</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items" :key="item.id"
              class="hover:bg-gray-50 transition">
            <td class="text-center p-1 border text-[8px]">{{ index + 1 }}</td>
            <td class="text-center  items-center border w-12 p-1">
              <img
                  :src="img_source(item.pic)"
                  class="w-10 h-10 rounded-lg object-cover border border-gray-200"
              >
            </td>
            <td class="text-center p-1 border text-[8px] w-24">{{ item.group_id || '---' }}</td>
            <td class="text-center p-1 border text-[8px] w-24">{{ item.sku || '---' }}</td>
            <td class="text-center p-1 border text-[8px] w-min">
              {{ item && item.name !== undefined ? truncateText(item.name) : '' }}
              <div v-if="item.product_match_mode === 'existing'" class="text-blue-700 mt-1">محصول منتخب: {{ item.selected_product_name }} ({{ item.product }})</div>
              <div v-if="item.product_match_mode === 'new'" class="text-green-700 mt-1">ایجاد محصول جدید هنگام تحویل</div>
            </td>
            <td v-if="!packing.domestic" class="text-center p-1 border w-16 whitespace-nowrap">
              {{ item.box_stacking || '---' }}
            </td>
            <td v-if="!packing.domestic" class="text-center p-1 border w-16 whitespace-nowrap">{{
                item.quantity_per_box
              }}
            </td>
            <td v-if="!packing.domestic" class="text-center p-1 border w-8 ">{{ item.box_quantity }}</td>
            <td class="text-center p-1 border w-8 ">{{ item.total }}</td>
            <td v-if="packing.domestic" class="text-center p-1 border w-8 ">{{ item.regular_price | toMoney(0) }}</td>
            <td v-if="packing.domestic" class="text-center p-1 border max-w-xs">
              <span v-if="percentBelowRegular(item) !== null"
                    class="inline-flex items-center justify-center px-1.5 py-0.5 rounded-full text-[9px] font-medium"
                    :class="percentClass(percentBelowRegular(item))">
                {{ Math.round(percentBelowRegular(item)) }}%
              </span>
              <span v-else class="text-gray-400 text-[10px]">---</span>
            </td>


            <td class="text-[11px] border w-4 bg-blue-50 text-black">
              <div class="flex flex-col items-start pr-2">
                <div class="relative text-right">
                  <span class="text-gray-900 font-medium" v-if="!packing.domestic">
                    {{ item.price | toMoney(5) }}
                    <span class="text-green-900 text-[8px] absolute mr-2">
                      {{ currentCurrency.name }}
                    </span>
                  </span>
                  <span class="text-gray-900 font-medium" v-if="packing.domestic">
                    {{ item.price | toMoney(0) }}
                    <span class="text-green-900 text-[8px] absolute mr-2">
                      تومان
                    </span>
                  </span>
                </div>
                <span v-if="body.currency && !packing.domestic" class="block text-[10px]  text-center">
                  با ضریب (× {{ currentCurrency.exchange_rate_to_toman | toMoney }})
                </span>
                <span v-if="body.currency && !packing.domestic" class="block text-[10px]  text-center">
                  برابر با
                  {{ item.price * currentCurrency.exchange_rate_to_toman | toMoney(0) }}
                  تومان
                </span>
              </div>
            </td>
            <td class="text-center p-0.5 border w-12">
              <select
                  @change="changeType(item.id, $event.target.value)"
                  :value="profits[item.id].type"
                  class="text-center w-full px-1 py-0.5 text-[10px] border border-gray-300 rounded  focus:outline-none ring-1 ring-blue-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
              >
                <option value="percent">درصد</option>
                <option value="amount">مبلغ</option>
              </select>
            </td>
            <td class="text-center p-0.5 border w-10">
              <div class="relative rounded-md shadow-sm">
                <input
                    @change="changeAmount(item.id, $event.target.value)"
                    :value="profits[item.id].amount"
                    type="number"
                    min="0"
                    class="text-center w-full px-1 py-0.5 text-[10px] border border-gray-300 rounded  focus:outline-none ring-1 ring-blue-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                >
              </div>

            </td>
            <td class="text-[11px] text-center py-1 px-2 border w-4 bg-blue-50 text-black">
              {{ profits[item.id].priceWithProfit | toMoney(0) }}
              <span class="text-[7px]">
                تومان
              </span>
            </td>

          </tr>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="items.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">
              یافت نشد
            </td>
          </tr>
          </tbody>

          <!-- Sticky Footer Summary -->
          <tfoot class="sticky-footer">
          <tr>
            <!-- تا ستون «قیمت مصرف‌کننده» (یا معادلش) سلول خالی می‌گذاریم -->
            <td class="p-1 border bg-white/90" colspan="5"></td>
            <td v-if="!packing.domestic" class="p-1 border bg-white/90"></td>
            <td v-if="!packing.domestic" class="p-1 border bg-white/90"></td>
            <td v-if="!packing.domestic" class="p-1 border bg-white/90"></td>
            <td class="p-1 border bg-white/90"></td>
            <td v-if="packing.domestic" class="p-1 border bg-white/90 text-center text-[11px] font-semibold">
              {{ totalRegularPriceSum | toMoney(0) }}
            </td>
            <td v-if="packing.domestic" class="p-1 border bg-white/90"></td>

            <!-- جمع قیمت پایه -->
            <td class="p-1 border bg-white/90 text-center">
              <div class="text-[11px] font-semibold" v-if="!packing.domestic">
                {{ totalBasePriceSum | toMoney(5) }}
                <span class="text-[9px]"> {{ currentCurrency.name }} </span>
                <div v-if="body.currency" class="text-[10px] mt-0.5">
                  ≈ {{ totalBasePriceSum * currentCurrency.exchange_rate_to_toman | toMoney(0) }} تومان
                </div>
              </div>
              <div class="text-[11px] font-semibold" v-else>
                {{ totalBasePriceSum | toMoney(0) }} <span class="text-[9px]">تومان</span>
              </div>
            </td>

            <!-- نوع حاشیه سود -->
            <td class="p-1 border bg-white/90"></td>

            <!-- مقدار حاشیه سود -->
            <td class="p-1 border bg-white/90"></td>

            <!-- جمع «در صورت فروش» (priceWithProfit) -->
            <td class="p-1 border bg-white/90 text-center text-[11px] font-extrabold">
              {{ totalPriceWithProfitSum | toMoney(0) }} <span class="text-[9px]">تومان</span>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2">تایید شد</div>

        <button @click="showNotification = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            />
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
import PackingStoreHandle from "@/modules/store_handle/PackingStoreHandle";
import StoreSelect from "@/components/selects/StoreSelect";
import CleaveMoney from "@/components/mcomponents/cleave/Money";

export default {
  name: 'AllStoreWaitForHandling',
  components: {CleaveMoney, StoreSelect, PackingStoreHandle},
  props: {
    id: {},
  },
  data() {
    return {
      searchGroup: '',
      showNotification: false,
      bulkType: 'percent',
      bulkAmount: 'percent',
      showBulkUpdate: false,
      showBulkAmountUpdate: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      items: [],
      currencies: [],
      suppliers: [],
      packing: {},
      totalPackages: 0,
      currentPage: 1,
      isSubmitting: false,
      activePricing: [],
      itemsPerPage: 20,
      body: {
        title: '',
        factor_number: '',
        supplier: null,
        currency: null,
        explanation: '',
        cargo_cost_per_shipping: null,
        initial_shipping_cost: 0,
        additional_shipping_cost: 0,
      },
      categories: [],
      brands: [],
      profits: {},
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    itemsWithFinalAmount() {
      return this.items.map(item => {
        const base = parseFloat(item.price * this.currentCurrency.exchange_rate_to_toman || 0)
        const profit = parseFloat(item.profit_amount || 0)
        const finalAmount = item.profit_type === 'percent' ? base * (1 + profit / 100) : base + profit
        return {
          ...item,
          finalAmount
        }
      })
    },

    filteredItems() {
      if (!this.searchGroup) return this.items
      return this.items.filter(item =>
          item.group_id && item.group_id.toString().includes(this.searchGroup)
      )
    },

    currentCurrency() {
      if (!this.body.currency) {
        return {
          name: ' ',
          exchange_rate_to_toman: 1,
        }
      } else {
        return this.currencies.find(c => c.id === this.body.currency);

      }

    },
    totalPrice() {
      return this.items.reduce((sum, item) => sum + (item.price || 0), 0);
    },
    totalQuantityPerBox() {
      return this.items.reduce((sum, item) => sum + (item.quantity_per_box || 0), 0);
    },
    totalBoxQuantity() {
      return this.items.reduce((sum, item) => sum + (item.box_quantity || 0), 0);
    },
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.total_quantity || 0), 0);
    },
    totalAmount() {
      return this.items.reduce((sum, item) => sum + ((item.price || 0) * (item.total || 1)), 0);
    },
    totalRegularPriceSum() {
      if (!this.packing?.domestic) return 0
      return this.items.reduce((s, it) => {
        const qty = Number(it.total) || 0
        const reg = Number(it.regular_price) || 0
        return s + reg * qty
      }, 0)
    },

    totalBasePriceSum() {
      return this.items.reduce((s, it) => {
        const qty = Number(it.total) || 0
        const price = Number(it.price) || 0
        return s + price * qty
      }, 0)
    },

    totalPriceWithProfitSum() {
      return this.items.reduce((s, it) => {
        const qty = Number(it.total) || 0
        const unitWithProfit = Number(this.profits[it.id]?.priceWithProfit || 0)
        return s + unitWithProfit * qty
      }, 0)
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    percentBelowRegular(item) {
      if (!this.packing?.domestic) return null
      const reg = Number(item?.regular_price || 0)
      const price = Number(item?.price || 0)
      if (!reg || reg <= 0 || price < 0) return null
      const diff = ((reg - price) / reg) * 100
      return diff > 0 ? diff : 0
    },
    percentClass(p) {
      if (p > 40) {
        return 'bg-green-100 text-green-700 border border-green-200'
      } else if (p >= 30) {
        return 'bg-blue-100 text-blue-700 border border-blue-200'
      } else if (p >= 20) {
        return 'bg-orange-100 text-orange-700 border border-orange-200'
      } else {
        return 'bg-red-100 text-red-700 border border-red-200'
      }
    },
    changeType(id, value) {
      const price = this.currentCurrency.exchange_rate_to_toman * parseFloat(this.profits[id].price)
      this.$set(this.profits[id], 'type', value)

      const newPriceWithProfit = (value === 'amount')
          ? parseFloat(price) + parseFloat(this.profits[id].amount)
          : parseFloat(price) + (parseFloat(price) / 100 * parseFloat(this.profits[id].amount))

      this.$set(this.profits[id], 'priceWithProfit', newPriceWithProfit)
    },
    changeAmount(id, value) {
      const price = this.currentCurrency.exchange_rate_to_toman * this.profits[id].price
      this.$set(this.profits[id], 'amount', value)

      const newPriceWithProfit = (this.profits[id].type === 'amount')
          ? parseFloat(price) + parseFloat(this.profits[id].amount)
          : parseFloat(price) + (parseFloat(price) / 100 * parseFloat(this.profits[id].amount))

      this.$set(this.profits[id], 'priceWithProfit', newPriceWithProfit)
    },
    calculateAllProfits() {
      const rate = this.currentCurrency.exchange_rate_to_toman

      Object.keys(this.profits).forEach(id => {
        const profit = this.profits[id]
        const price = rate * profit.price

        const newPriceWithProfit =
            profit.type === 'amount'
                ? parseFloat(price) + parseFloat(this.profits[id].amount)
                : parseFloat(price) + (parseFloat(price) / 100 * parseFloat(this.profits[id].amount))

        this.$set(this.profits[id], 'priceWithProfit', newPriceWithProfit)
      })
    },
    bulkTypeUpdate(value) {
      const rate = this.currentCurrency.exchange_rate_to_toman

      Object.keys(this.profits).forEach(id => {
        this.$set(this.profits[id], 'type', value)
        const profit = this.profits[id]
        const price = rate * profit.price

        const newPriceWithProfit =
            profit.type === 'amount'
                ? parseFloat(price) + parseFloat(this.profits[id].amount)
                : parseFloat(price) + (parseFloat(price) / 100 * parseFloat(this.profits[id].amount))

        this.$set(this.profits[id], 'priceWithProfit', newPriceWithProfit)
      })
      this.showBulkUpdate = false
    },
    bulkAmountUpdate(value) {
      const rate = this.currentCurrency.exchange_rate_to_toman
      Object.keys(this.profits).forEach(id => {
        this.$set(this.profits[id], 'amount', value)
        const profit = this.profits[id]
        const price = rate * profit.price

        const newPriceWithProfit =
            profit.type === 'amount'
                ? parseFloat(price) + parseFloat(this.profits[id].amount)
                : parseFloat(price) + (parseFloat(price) / 100 * parseFloat(this.profits[id].amount))

        this.$set(this.profits[id], 'priceWithProfit', newPriceWithProfit)
      })
      this.showBulkAmountUpdate = false

    },
    truncateText(text) {
      if (!text) return ''
      return text.length > 50 ? text.slice(0, 35) + '...' : text
    },

    calculateRowIndex(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    viewDetails(packageItem) {
      alert(`جزئیات بسته: ${packageItem.name}\nشناسه: ${packageItem.id}\nتعداد آیتم‌ها: ${packageItem.items_count}`);
    },
    downloadFile(packageItem) {
      if (!packageItem.uploaded_file) {
        this.showNotificationMessage('فایل آپلود شده موجود نیست', 'error');
        return;
      }

      this.showNotificationMessage('در حال دانلود فایل...', 'success');
      setTimeout(() => {
        this.showNotificationMessage('فایل با موفقیت دانلود شد', 'success');
      }, 1500);
    },
    exportToExcel() {
      this.showNotificationMessage('در حال آماده‌سازی خروجی Excel...', 'success');
      setTimeout(() => {
        this.showNotificationMessage('خروجی Excel با موفقیت تولید شد', 'success');
      }, 2000);
    },

    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    handleDone() {
      let url = `entrance/createChinaEntrancePackageFromExtracted/${this.id}`
      if (this.packing.domestic) {
        url = `entrance/createDomesticEntrancePackageFromExtracted/${this.id}`
      }
      if (!this.body.currency && !this.packing.domestic) {
        window.alert('ارز را انتخاب کنید')
      }
      const cleanBody = Object.fromEntries(
          Object.entries(this.body).filter(([key, value]) => value != null)
      );
      cleanBody['items'] = this.profits
      this.isSubmitting = true

      this.request({
        url: this.endpoint(url),
        method: 'post',
        data: cleanBody,
        success: (data) => {
          this.isSubmitting = false
          this.showNotificationMessage()
          if (this.packing.domestic) {
            this.$router.push(`/panel/domesticPackageList`)
          } else {
            this.$router.push(`/panel/ChinaPackingList`)
          }

        },
        error: () => {
          this.isSubmitting = false
          window.alert("مشکلی پیش اومده")
        }

      })
    },
    fetchPacking() {
      this.loading = true

      this.request({
        url: this.endpoint(`file_handler/extractedEntrancePackageDetail/${this.id}`),
        method: 'get',
        success: (data) => {
          this.packing = data
          this.items = data.items
          data.items.forEach(item => {
            if (!this.profits[item.id]) {
              this.$set(this.profits, item.id, {
                type: 'percent',
                amount: 0,
                price: item.price,
                priceWithProfit: item.price * (this.currentCurrency.exchange_rate_to_toman || 1)
              });
            }
          });
          this.totalPackages = 0
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchPacking()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        name__icontains: '',
      }
      this.applyFilters()
    },

    refreshProducts() {
      this.fetchPacking()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchPacking()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchPacking()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchPacking()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true

    },
    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },

    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },
    fetchSuppliers() {
      this.request({
        url: this.endpoint('main/supplier'),
        method: 'get',
        success: (data) => {
          this.suppliers = data
        }
      })
    },

  },
  mounted() {
    this.fetchCurrency()
    this.fetchSuppliers()
    this.fetchPacking()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}

.sticky-head th {
  position: sticky;
  top: 0;
  z-index: 20;
}

.sticky-footer tr {
  position: sticky;
  bottom: 0;
  z-index: 15;
}
</style>
